import vuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import Vue from 'vue'

Vue.use(vuelidateErrorExtractor, {
  /**
   * Optionally provide the template in the configuration.
   * or register like so Vue.component("FormField", templates.singleErrorExtractor.foundation6)
   */
  template: templates.singleErrorExtractor.foundation6, // you can also pass your own custom template

})
